import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as chatSelectors from '../store/selectors/chat.selector';

@Injectable({
  providedIn: 'root'
})
export class PendingMessagesService {
  constructor(private store: Store) {}

  setPendingMessages(messages: any): void {
    localStorage.setItem('pendingMessages', JSON.stringify(messages));
  }

  getPendingMessages(): Observable<any> {
    return this.store.select(chatSelectors.selectPendingMessages).pipe(
      map(messages => {
        if (messages && messages.length > 0) {
          this.setPendingMessages(messages);
          return messages;
        } else {
          const localStorageMessages = localStorage.getItem('pendingMessages');
          return localStorageMessages ? JSON.parse(localStorageMessages) : [];
        }
      }),
      catchError(() => {
        const localStorageMessages = localStorage.getItem('pendingMessages');
        return of(localStorageMessages ? JSON.parse(localStorageMessages) : []);
      })
    );
  }

  clearPendingMessages(service_id: number): void {
    const localStorageMessages = localStorage.getItem('pendingMessages');
    if (localStorageMessages) {
      const messages = JSON.parse(localStorageMessages);
      const updatedMessages = messages.filter((msg: any) => msg.service_id !== service_id);
      localStorage.setItem('pendingMessages', JSON.stringify(updatedMessages));
    }
}
}